import { Injectable } from '@angular/core';
import { ScreenService } from 'lib/screen/index.js';

export type LayoutSize = 'large' | 'medium' | 'small' | 'full';

export type LayoutStyles = {
	readonly [cssType: string]: string;
};

@Injectable({
	providedIn: 'root'
})
export class LayoutUiService {
	private readonly largeLayoutWidthInPx: number = 1600;
	private readonly largeLayoutWidth: string = `${this.largeLayoutWidthInPx}px`;

	private readonly mediumLayoutWidthInPx: number = 1080;
	private readonly mediumLayoutWidth: string = `${this.mediumLayoutWidthInPx}px`;

	private readonly smallLayoutWidthInPx: number = 640;
	private readonly smallLayoutWidth: string = `${this.smallLayoutWidthInPx}px`;

	getLayoutSizeStyles(data: {
		readonly type: LayoutSize | undefined;
		readonly screenService: ScreenService;
	}): LayoutStyles {
		let width: string = '100%';
		const currentScreen = data.screenService.currentScreen();

		if (currentScreen.isMobileView) {
			width = '100%';
		} else if (data.type) {
			if (data.type === 'large') {
				width = this.largeLayoutWidth;
			} else if (data.type === 'medium') {
				width = this.mediumLayoutWidth;
			} else if (data.type === 'small') {
				width = this.smallLayoutWidth;
			} else if (data.type === 'full') {
				width = '100%';
			}
		} else {
			width = '100%';
		}

		if (width === '100%') {
			return {
				width: `100%`
			};
		}

		return {
			width: `100%`,
			'max-width': `${width}`,
			'margin-left': 'auto',
			'margin-right': 'auto'
		};
	}
}
